var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    [
      _c(
        "w-row",
        { style: { flexWrap: "nowrap" } },
        [
          _c("w-tabs", {
            style: { marginTop: "0", flexShrink: 1, flexGrow: 1 },
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
          _c(
            "div",
            { style: { flexShrink: 0 } },
            [
              _vm.isDevMode
                ? _c(
                    "w-button-bar",
                    { staticClass: "mr" },
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("download-settings"),
                              expression: "$ct('download-settings')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.downloadSettings()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "download" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("upload-settings"),
                              expression: "$ct('upload-settings')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.openUploadSettingsModal()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "upload" } })],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-button-bar",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("save-settings"),
                          expression: "$ct('save-settings')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.saveReportSettings()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "save" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("save-as-settings"),
                          expression: "$ct('save-as-settings')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.saveAsReportSettings()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { far: "", icon: ["far", "save"] } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("load-settings"),
                          expression: "$ct('load-settings')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.openSavedReports()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "folder-open" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("change-data-source"),
                          expression: "$ct('change-data-source')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.openChangeDataSourceModal()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "database" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fast-fade", mode: "out-in" } },
        [
          _vm.tab == 0
            ? _c("app-columns", {
                attrs: { value: _vm.value, model: _vm.model },
              })
            : _vm.tab == 1
            ? _c("app-filters", {
                attrs: { value: _vm.value, model: _vm.model },
              })
            : _vm.tab == 2
            ? _c("app-groups", {
                attrs: { value: _vm.value, model: _vm.model },
              })
            : _vm.tab == 3
            ? _c("app-sorting", {
                attrs: { value: _vm.value, model: _vm.model },
              })
            : _vm.tab == 4
            ? _c("app-summary-edit", {
                attrs: { value: _vm.value, model: _vm.model },
              })
            : _vm.tab == 5
            ? _c("app-page-settings", { attrs: { value: _vm.value } })
            : _vm.tab == 6
            ? _c("app-advanced-settings", {
                attrs: { value: _vm.value, model: _vm.model },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.saveSettingsModalOpened,
            callback: function ($$v) {
              _vm.saveSettingsModalOpened = $$v
            },
            expression: "saveSettingsModalOpened",
          },
        },
        [
          _c("app-save-report-settings-card", {
            attrs: { settings: _vm.value, "browse-id": _vm.browseId },
            on: {
              close: function ($event) {
                _vm.saveSettingsModalOpened = false
              },
              save: function ($event) {
                return _vm.onSave($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.loadSettingsModalOpened,
            callback: function ($$v) {
              _vm.loadSettingsModalOpened = $$v
            },
            expression: "loadSettingsModalOpened",
          },
        },
        [
          _vm.loadSettingsModalOpened
            ? _c("app-load-report-settings-card", {
                attrs: { "browse-id": _vm.browseId, "overwrite-flag": true },
                on: {
                  close: function ($event) {
                    _vm.loadSettingsModalOpened = false
                  },
                  load: (...args) => _vm.onSettingsLoad(args[0], args[1]),
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.uploadSettingsModalOpened,
            callback: function ($$v) {
              _vm.uploadSettingsModalOpened = $$v
            },
            expression: "uploadSettingsModalOpened",
          },
        },
        [
          _vm.uploadSettingsModalOpened
            ? _c("app-upload-report-settings-card", {
                on: {
                  close: function ($event) {
                    _vm.uploadSettingsModalOpened = false
                  },
                  input: function ($event) {
                    return _vm.onSettingsLoad($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }